(ns app.domain.attachment.model
  (:require [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.db.child-entity :as child]
            [core.db.entity.util :as eu]))

(def show-attachments-from-related-phases-states
  "List of states in which attachment from this phase are visible in related workspaces"
  #{:state.application/permit-issued})

(def ^{:arglists '([attachment-type lang])} attachment-type-label
  (i18n-model/translation-fallback-fn :attachment-type/names))

(defn attachment-title [lang attachment]
  (->> attachment
       :attachment/types
       (map #(attachment-type-label % lang))
       sort
       (str/join ", ")))

(defmethod group-model/get-authority-group :entity.type/attachment-type
  [attachment-type]
  (:attachment-type/authority-group attachment-type))

(defmethod i18n-model/get-localized-string-attrs :entity.type/attachment-type [_]
  [:attachment-type/names
   :attachment-type/descriptions])

(defn attachment-for-version
  "Returns the parent attachment of an attachment version by reverse keyword navigation
  through `:attachment/_versions`."
  [attachment-version]
  (:attachment/_versions attachment-version))


(defn latest-attachment-version [attachment]
  (->> attachment
       :attachment/versions
       (sort-by :attachment.version/version)
       last))

(defn latest-non-markup-version [attachment]
  (->> attachment
       :attachment/versions
       (remove :attachment.version/authority-markup?)
       (sort-by :attachment.version/version)
       last))

(defn latest-file-version-of-attachment-version [attachment-version]
  (-> attachment-version :attachment.version/files eu/latest))


(defn latest-file-version [attachment]
  (-> attachment
      latest-attachment-version
      latest-file-version-of-attachment-version))

(defn is-archivable? [attachment]
  (-> attachment latest-file-version :attachment.version.file/archivable boolean))

(defn is-valid? [attachment]
  (or (-> attachment latest-file-version :attachment.version.file/valid-pdf? boolean)
      (is-archivable? attachment)))

(def edn-content-type "application/edn; charset=utf-8")
(def pdf-content-type "application/pdf")
(def zip-content-type "application/zip")

(def allowed-image-types ["image/heic"
                          "image/heif"
                          "image/png"
                          "image/jpeg"
                          "image/tiff"])

(def allowed-media-types (conj allowed-image-types "application/pdf"))

(defn image? [file]
  (contains? (set allowed-image-types) (:file/content-type file)))

(def ^{:arglists '([phase-entity])} phase-attachments
  (child/child-entities-of-type-fn :entity.type/attachment))

(def committee-categories
  [:committee-category/map
   :committee-category/drawing])



(def supported-pdf-features
  #{:pdf-feature/pdfa
    :pdf-feature/signed})
